<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Claims</h4>
        </div>
    </div>
    <div class="row mt-4"
    *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined && global.globalAgencyId!=0 && global.globalAgencyId != '' && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'; else elsecondition">
        <div class="col-12 mt-3 p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body transparent">
                <div>
                    <div class="row mb-2">
                        <div class="col-lg-3 col-md-9 col-sm-9 col-xs-12">
                            <label class=" font-header mt-1 me-2" style="font-size: 16px;">837P</label>
                            <label class="toggle-control">
                                <input type="checkbox" [(ngModel)]="is87IClaimBoolean" (ngModelChange)="switchchange()"
                                    id="toggle837IorP" [ngModelOptions]="{standalone: true}">
                                <label class="font-header ms-2 mt-1 me-2" style="font-size: 16px;">837I</label>
                                <span class="control "></span>
                            </label>
                        </div>
                        <div class="col-lg-9 col-md-7 col-sm-8 col-xs-12 text_right font-header">
                            <button type="button" class="btn blue-btn btn-sm text_right  mb-1 ms-1" data-bs-toggle="modal"
                                id="ExportasCSVButton" [disabled]="global.globalAgencyId == 0 || !isEnabledExcel"
                                data-bs-target="#exportascsvmodel" (click)="isServicelineExport=false">
                                Export as CSV
                            </button>
                            <button type="button" class="btn blue-btn btn-sm text_right marginright mb-1 ms-1" (click)="reexport()"
                                [disabled]="ClaimMasterIds.length == 0" id="ReExportButton"
                                *ngIf="claimsOptions.tabsChanges == 'ActiveClaims'">
                                Re-Export
                            </button>

                            <!-- Restore to active -->
                            <button type="button" class="btn blue-btn btn-sm text_right marginright mb-1 ms-1"
                                (click)="RestoreActive()" [disabled]="ClaimMasterIds.length == 0"
                                *ngIf="claimsOptions.tabsChanges == 'ArchiveClaims'" id="RestoretoActiveButton">
                                Restore to active
                            </button>
                            <button type="button" class="btn blue-btn btn-sm text_right marginright mb-1 ms-1"
                                (click)="isViewQR=true" [disabled]="global.globalAgencyId == 0" data-bs-toggle="modal"
                                data-bs-target="#QRInvoiceinfo" id="ImportPaymentQRButton">
                                Import Payment QR
                            </button>
                            <!-- View batches -->
                            <button type="button" class="btn blue-btn btn-sm text_right marginright mb-1 ms-1"
                                (click)="isViewbatches=true" [disabled]="global.globalAgencyId == 0" data-bs-toggle="modal"
                                data-bs-target="#batchinfo" id="ViewbatchesButton">
                                View batches
                            </button>
                            <button type="button" class="btn blue-btn btn-sm text_right marginright mb-1 ms-1"
                                data-bs-target="#exportascsvmodel" data-bs-toggle="modal" (click)="isServicelineExport=true"
                                id="ExportServiceLineButton">
                                Export Service Line
                            </button>
                            <button type="button" class="btn blue-btn btn-sm text_right marginright ms-1 mb-1"
                                [disabled]="this.ClaimMasterIds?.length==0" data-bs-toggle="modal"
                                *ngIf="claimsOptions.tabsChanges !='ArchiveClaims'" data-bs-target="#markAsPaid"
                                (click)="MakeMarkServicePaid()" id="MarkAsPaidinFullButton">
                                Mark As Paid in Full
                            </button>
                        </div>
                    </div>
                    <!-- Group ,Payer,Resubmission,Claim Status -->
                    <div class="row ">
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Group </label>
                            </div>
                            <div class="col-lg-12 d-inline-flex">
                                <select class="form-control" [(ngModel)]="ListBO.groupId" (ngModelChange)="
                            setGroupValues(ListBO.groupId);" [disabled]="global.globalAgencyId == 0" id="Group">
                                    <option></option>
                                    <option [value]="st.id" *ngFor="let st of groupList">
                                        {{ st.lovName }}
                                    </option>
                                </select>
                                <app-dropdown *ngIf="global.globalAgencyId != 0"
                                    (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')"></app-dropdown>
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Payer </label>
                            </div>
                            <div class="col-lg-12">
                                <select class="form-control" [(ngModel)]="ListBO.payerId" id="Payer"
                                    [disabled]="global.globalAgencyId == 0" (ngModelChange)="
                            setPayerValues(ListBO.payerId);
     
    " [disabled]="ListBO.groupId == null ||ListBO.groupId == undefined || ListBO.groupId =='00000000-0000-0000-0000-000000000000'">
                                    <option></option>
                                    <option [value]="st.value" *ngFor="let st of payorList">
                                        {{ st.label }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Resubmission </label>
                            </div>
                            <div class="col-lg-12 d-inline-flex">
                                <select class="form-control" [(ngModel)]="ListBO.resubmissionLid" id="Resubmission"
                                    [disabled]="global.globalAgencyId == 0">
                                    <option></option>
                                    <option [value]="st.id" *ngFor="let st of ResubmissionList">
                                        {{ st.lovName }}
                                    </option>
                                </select>
                                <app-dropdown *ngIf="global.globalAgencyId != 0"
                                    (EmitRefreshClick)="refreshToGetDropDownValues('RESUBMISSION')"></app-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Claim Status </label>
                            </div>
                            <div class="col-lg-12 d-inline-flex">
                                <select class="form-control" [(ngModel)]="ListBO.claimStatus " id="ClaimStatus"
                                    [disabled]="global.globalAgencyId == 0">
                                    <option></option>
                                    <option [value]="st" *ngFor="let st of dropdata">
                                        {{ st }}
                                    </option>
                                </select>
                                <app-dropdown *ngIf="global.globalAgencyId != 0"
                                    (EmitRefreshClick)="refreshToGetDropDownValues('CLAIMFILTERSTATUS')"></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <!-- From ,To,Service Code -->
                    <div class="row mt-2">
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">From </label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptionsheader" [selDate]="ListBO.fromDate"
                                    id="ClaimsFromDate" placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event, 'inputchage', 'filterstart')"
                                    (dateChanged)="newdates($event, 'datechagned', 'filterstart')"
                                    [disabled]="this.global.globalAgencyId == 0">
                                </my-date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">To </label>
                            </div>
                            <div class="col-lg-12">
                                <my-date-picker [options]="myDatePickerOptionsheader" [selDate]="ListBO.toDate"
                                    id="ClaimsToDate" placeholder="mm/dd/yyyy"
                                    (inputFieldChanged)="newdates($event, 'inputchage', 'filterend')"
                                    (dateChanged)="newdates($event, 'datechagned', 'filterend')"
                                    [disabled]="this.global.globalAgencyId == 0">
                                </my-date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3 mt-2">
                            <div class="col-lg-12">
                                <div class="d-flex mt-4">
                                    <input type="radio" class="mb-2" [(ngModel)]="ListBO.dateFilterType" name="datetype"
                                        value="fromdate" id="ClaimsRadioFromDate">
                                    <label style="font-weight:bold" class="ms-2">From Date</label>
                                    <input type="radio" class=" mb-2 ms-4" [(ngModel)]="ListBO.dateFilterType"
                                        id="ClaimsRadioToDate" name="datetype" value="preparedDate">
                                    <label style="font-weight:bold" class="ms-2">Prepared Date</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Under Billed </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [items]="UnderbilledList" [(ngModel)]="ListBO.underbilled"
                                    [searchable]="true" [clearable]="true" bindLabel="Value" bindValue="Key"
                                    id="ClaimsUnderBilled"></ng-select>
                            </div>
                        </div>


                    </div>
                    <!-- Employee ,Client -->
                    <div class="row mt-2">
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Employee </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [disabled]="global.globalAgencyId==0" [clearable]="true" id="ClaimsEmployee"
                                    [items]="employeelists" bindLabel="names" 
                                    bindValue="id"
                                    [disabled]="global.globalAgencyId == 0" [(ngModel)]="ListBO.employeeId">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Client </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [disabled]="global.globalAgencyId==0" [searchable]="true" [clearable]="true"
                                    id="ClaimsClient" [items]="clientlistwithstatus"  bindLabel="names"
                                    bindValue="id"
                                    [(ngModel)]="ListBO.clientId">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Service Code </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [(ngModel)]="ListBO.masterServiceId" [searchable]="true" [clearable]="true"
                                    id="ClaimsServiceCode" [items]="service" bindLabel="Value" bindValue="Key"
                                    groupBy="type">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{item.type}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Company </label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [disabled]="global.globalAgencyId==0" [clearable]="true" id="ClaimsCompany"
                                    [items]="companyList" bindLabel="Value" bindValue="Key"
                                    [disabled]="global.globalAgencyId == 0" [(ngModel)]="ListBO.companyId">
                                </ng-select>
                            </div>
                        </div>

                    </div>
                    <!-- Company ,Apply Clear -->
                    <div class="row mt-4">   
                        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <label *ngIf="selectedGroupName != 'PP'">Clearing House <sup
                                    class="super-script" style="font-weight:bold">*</sup></label>

                            <label *ngIf="selectedGroupName == 'PP'" style="font-weight:bold">Client</label>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <select *ngIf="selectedGroupName != 'PP'" id="ClaimsClientSelect"
                                [disabled]="global.globalAgencyId == 0" class="form-control"
                                [(ngModel)]="batchList.clearingHouseId">
                                <option [value]="st.Key" *ngFor="let st of clearingHouseList">
                                    {{ st.Value }}
                                </option>
                            </select>

                            <ng-select *ngIf="selectedGroupName == 'PP'" [(ngModel)]="ListBO.pPClientId"
                                id="ClaimsClientSelect" [clearable]="true" [items]="clientlist"
                                [searchable]="true" [disabled]="global.globalAgencyId == 0"
                                bindLabel="names"
                                bindValue="id" class="w100" (change)="Applyfilter()">
                            </ng-select>
                        </div>                                        
                           
                            <div class="col-lg-6">
                               
    <!-- <input type="checkbox"  class=" mb-2 ms-2" [(ngModel)]="ListBO.isNeedToReprocessed"
                               (ngModelChange)="Applyfilter()" >
                               
                                 <label style="font-weight:bold" class="ms-2">Needs Reprocessed</label> -->

                                 <div >                           
                                 
                                    <button type="button" class="btn blue-btn btn-sm me-4  " id="ClaimsApplyButton"
                                    [disabled]="global.globalAgencyId == 0" (click)="Applyfilter()">
                                    Apply
                                </button>                                                                
                            
                                <button type="button" class="btn blue-btn btn-sm ms-2 " id="ClaimsClearButton"
                                [disabled]="global.globalAgencyId == 0" (click)="ClearValues()">
                                Clear
                            </button>
                             
                                                         
                                </div>
                            
                            </div>
                        

                    </div>
                    <!-- Clearing House,client,Delete,Create,Generate Invoice,Email to CLient -->
                    <div class="row mb-2 pl-3">
                        <div class="col pl-0">

                            <label class="star mt-2"><i>Note: * fields are mandatory</i></label>
                            <div class="card-body widget-body pt-2 mt-1">
                               
                                    <div class="row mt-1 mb-2">
                                        <div class="col-lg-12 ">
                                      
                                          <span *ngIf="selectedGroupName != 'PP'" id="spancreatebatch" data-bs-toggle="modal" data-bs-target="#CreateBatchDetail"></span>
                                          
                                          <button *ngIf="selectedGroupName != 'PP' && claimsOptions.tabsChanges == 'ReadyClaims'"
                                            class="btn btn-sm me-2"
                                            [disabled]="batchList.clearingHouseId == null || batchList.clearingHouseId == '' || batchList.clearingHouseId == undefined || isClaimsSelectedId.length == 0"
                                            (click)="createBatchDetailsFile()">
                                            Create
                                          </button>
                                      
                                          <button *ngIf="selectedGroupName != 'PP' && claimsOptions.tabsChanges == 'ActiveClaims'"
                                            class="btn btn-sm me-2"
                                            [disabled]="batchList.clearingHouseId == null || batchList.clearingHouseId == '' || batchList.clearingHouseId == undefined || isClaimsSelectedId.length == 0"
                                            (click)="ActivecreateBatchFile()">
                                            Create
                                          </button>
                                      
                                          <button class="btn btn-sm me-2"
                                            [hidden]="global.agencyCode != 'SUPERADMIN'"
                                            [disabled]="isClaimsSelectedId.length == 0"
                                            (click)="showClaimsDeletePopUp()">
                                            Delete
                                          </button>
                                      
                                          <button *ngIf="claimsOptions.tabsChanges == 'ActiveClaims'"
                                            class="btn btn-sm me-2"                                            
                                            [disabled]="ClaimMasterIds.length == 0"
                                            (click)="MovetoArchive()">
                                            Move to Archive
                                          </button>
                                      
                                          <span *ngIf="selectedGroupName == 'PP'" id="spancreatebatch" data-bs-toggle="modal" data-bs-target="#CreateBatchDetail"></span>
                                      
                                          <button *ngIf="selectedGroupName == 'PP' && (claimsOptions.tabsChanges == 'ReadyClaims' || claimsOptions.tabsChanges == 'ActiveClaims')"
                                            class="btn btn-sm me-2"
                                            [disabled]="isClaimsSelectedId.length == 0"
                                            (click)="getEmailToClient()">
                                            Email To Client
                                          </button>
                                      
                                          <button *ngIf="selectedGroupName == 'PP' && (claimsOptions.tabsChanges == 'ReadyClaims' || claimsOptions.tabsChanges == 'ActiveClaims')"
                                            class="btn btn-sm me-2"
                                            [disabled]="isClaimsSelectedId.length == 0 || ListBO.groupId == null || ListBO.groupId == undefined || ListBO.groupId == 0"
                                            (click)="GenerateClaimsInvoiceList()">
                                            Generate Invoice
                                          </button>
                                      
                                        </div>
                                      </div>
                                      
  
                                    
                                  
                                    
                                  
                                    
                                  
                                 
                                  
                                <!-- TAB -->
                                <div class="row mb-2">
                                    <div class="col ">
                                        <div widget class="card border-0 box-shadow" style="min-height: 500px;">
                                            <div class="card-body widget-body pt-2">
                                                <div *ngIf="global.globalAgencyId==0" class="text-center text-danger">
                                                    <label class="font-red"><i
                                                            class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                                        agency to view
                                                        details</label>
                                                </div>
                                                <section id="tabs" class="project-tab" *ngIf="global.globalAgencyId!=0">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <!-- Navigation Links -->
                                                            <nav>
                                                                <div class="nav nav-tabs nav-fill" id="nav-tab"
                                                                    role="tablist">
                                                                    <a class="nav-item nav-link active"
                                                                        id="nav-Ready To Bill-tab" data-bs-toggle="tab"
                                                                        href="#nav-Ready To Bill" role="tab"
                                                                        aria-controls="nav-Ready To Bill"
                                                                        aria-selected="true"
                                                                        (click)="tabchange('ReadyClaims')"
                                                                        [ngClass]="{'mytab-inactive':claimsOptions.tabsChanges!='ReadyClaims','active':claimsOptions.tabsChanges=='ReadyClaims'}">Ready
                                                                        To Bill
                                                                    </a>
                                                                    <a class="nav-item nav-link"
                                                                        id="nav-ActiveClaims-tab" data-bs-toggle="tab"
                                                                        href="#nav-ActiveClaims" role="tab"
                                                                        aria-controls="nav-ActiveClaims"
                                                                        aria-selected="false"
                                                                        (click)="tabchange('ActiveClaims')"
                                                                        [ngClass]="{'mytab-inactive':claimsOptions.tabsChanges!='ActiveClaims','active':claimsOptions.tabsChanges=='ActiveClaims'}">Active
                                                                    </a>
                                                                    <a class="nav-item nav-link"
                                                                        id="nav-ArchiveClaims-tab" data-bs-toggle="tab"
                                                                        href="#nav-ArchiveClaims" role="tab"
                                                                        aria-controls="nav-ArchiveClaims"
                                                                        aria-selected="false"
                                                                        (click)="tabchange('ArchiveClaims')"
                                                                        [ngClass]="{'mytab-inactive':claimsOptions.tabsChanges!='ArchiveClaims','active':claimsOptions.tabsChanges=='ArchiveClaims'}">Archive
                                                                    </a>
                                                                </div>
                                                            </nav>
                                                            <!-- Tabs -->
                                                            <div class="tab-content" id="nav-tabContent">
                                                                <div class="row mb-2 mt-1">
                                                                    <div class="col-lg-12 pl-0">
                                                                         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update ClaimsTotalColumns constant in claims-list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'ClaimsGrid' maps to localStorage key 'gridClaimsGrid'
                                                                          -->
                                                                        <ejs-grid #gridClaims id='ClaimsGrid'   [allowReordering]="true" 
                                                                             [enablePersistence]="true"
                                                                            [dataSource]="data | async"
                                                                            [enablePersistence]="true"
                                                                            (rowSelected)='rowSelected($event)'
                                                                            [allowResizing]='true' [allowSorting]="true"
                                                                            allowPaging="true" [allowFiltering]="true"
                                                                            [pageSettings]="initialPage"
                                                                            (actionBegin)="onActionComplete($event)"
                                                                            [selectionSettings]="selectionOptions"
                                                                            [filterSettings]="filterSettings"
                                                                            [showColumnChooser]='true' (checkBoxChange)="
                                                            checkBoxChange($event)"
                                                                            (dataStateChange)="dataStateChange($event)"
                                                                            (resizeStop)="onResizeClaims($event)">
                                                                            <e-columns>
                                                                                <!-- 1.checkbox -->
                                                                                <e-column type="checkbox" uid="checkbox"
                                                                                    width="50"
                                                                                    textAlign="center"
                                                                                    [allowEditing]="true"
                                                                                    editType="booleanedit"
                                                                                    [showInColumnChooser]="false">
                                                                                </e-column>
                                                                                <!-- 2.Action -->
                                                                                <e-column headerText="Action"
                                                                                    width="100" uid="action"
                                                                                    [showInColumnChooser]="false"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #template let-data>
                                                                                        <button
                                                                                            *ngIf="claimsOptions.tabsChanges == 'ReadyClaims'"
                                                                                            class="btn btn-edit-table  text-center
                                                  " (click)="Claimsdatabind(data)">
                                                                                            <i class="fa fa-edit"></i>
                                                                                        </button>
                                                                                        <button
                                                                                            class="btn btn-edit-table text-center"
                                                                                            *ngIf="claimsOptions.tabsChanges == 'ActiveClaims' || claimsOptions.tabsChanges =='ArchiveClaims'"
                                                                                            (click)="Claimsdatabind(data)">
                                                                                            <i class="fa fa-eye"></i>
                                                                                        </button>
                                                                                        <button
                                                                                            *ngIf="claimsOptions.tabsChanges == 'ReadyClaims' ||claimsOptions.tabsChanges == 'ActiveClaims'"
                                                                                            class="btn btn-delete-table ms-4 text-center"
                                                                                            data-bs-target="#deleteclaim"
                                                                                            data-bs-toggle="modal"
                                                                                            (click)="setClaimmasterIds(data.id)">
                                                                                            <i class="fa fa-trash"></i>
                                                                                        </button>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 3.Client-->
                                                                                <e-column field="clientName"
                                                                                    width="140" headerText="Client"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 4.Prepared Date -->

                                                                                <e-column field="preparedDate"
                                                                              
                                                                                    headerText="Prepared Date"
                                                                                    width="200"
                                                                                    type="datetime"
                                                                                    [format]="formatOptions"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="true">
                                                                                </e-column>

                                                                                <!-- 5.Payor -->
                                                                                <e-column field="payerName"
                                                                                     headerText="Payor"
                                                                                    type="string"
                                                                                    width="200">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 6 .From Date-->
                                                                                <e-column field="fromDate" width="100"
                                                                                    headerText="From Date" type="date"
                                                                                    [allowFiltering]="false"
                                                                                    [format]="formatOptions">
                                                                                </e-column>
                                                                                <!-- 7.To Date -->
                                                                                <e-column field="toDate" width="100"
                                                                                    headerText="To Date" type="date"
                                                                                    [allowFiltering]="false"
                                                                                    [format]="formatOptions"></e-column>

                                                                                <!--8.Company  -->

                                                                                <e-column field="company" width="140"
                                                                                    headerText="Company" type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 9.Total Gross Charge -->
                                                                                <e-column field="grossCharge"
                                                                                    width="140"
                                                                                    headerText="Total Gross Charge"
                                                                                    textAlign="Right" 
                                                                                    type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 9.Total Amount -->
                                                                                <e-column field="totalCharge"
                                                                                    width="140"
                                                                                    headerText="Total Amt."
                                                                                    textAlign="Right" textAlign="Right"
                                                                                    type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>

                                                                                <!-- 11.SpendDownPaid -->
                                                                                <e-column field="spendDownPaid"
                                                                                    width="140"
                                                                                    headerText="SpendDownPaid"
                                                                                    textAlign="Right" textAlign="Right"
                                                                                    type="number">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 12.SpendDownCharge -->
                                                                                <e-column field="spendDownCharge"
                                                                                    width="140"
                                                                                    headerText="SpendDownCharge"
                                                                                    textAlign="Right" textAlign="Right"
                                                                                    type="number">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 13.paidAmount -->
                                                                                <e-column field="paidAmount"
                                                                                    width="180" textAlign="Right"
                                                                                    headerText="Paid Amt."
                                                                                    textAlign="Right" type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 14.Balance Due-->
                                                                                <e-column field="balanceAmount"
                                                                                    width="100"
                                                                                    headerText="Balance Due"
                                                                                    type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 15.note -->
                                                                                <e-column field="note" width="100"
                                                                                    headerText="Note" type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 16.patientControlNumbers -->
                                                                                <e-column field="patientControlNumbers"
                                                                                    width="140"
                                                                                    headerText="Patient Control Number"
                                                                                    type="number"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false"></e-column>
                                                                                <!-- 17.batchNumbers -->
                                                                                <e-column field="batchNumbers"
                                                                                    width="100" headerText="Batch No"
                                                                                    type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 18.Claim Id -->
                                                                                <e-column field="id" width="140"
                                                                                    headerText="Claim Id" type="number"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]="false">
                                                                                </e-column>

                                                                                <!-- 19.Status -->


                                                                                <e-column field="claimStatus"
                                                                                    headerText="Status" width="100"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-dropdownlist id="dropdown"
                                                                                            placeholder="Select  Status"
                                                                                            [dataSource]="dropdata"
                                                                                            [popupHeight]="height">
                                                                                        </ejs-dropdownlist>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- claimMaster_Status -->
                                                                                <e-column field="claimMaster_Status" width="140"
                                                                                    headerText="Alter Claim Status" type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>

                                                                                


                                                                                <!-- 20.Exported -->
                                                                                <e-column field="exported"
                                                                                    headerText="Exported" width="100"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-dropdownlist id="dropdown1"
                                                                                            placeholder="Select Exported"
                                                                                            [dataSource]="exportdatadata"
                                                                                            [popupHeight]="height">
                                                                                        </ejs-dropdownlist>
                                                                                    </ng-template>
                                                                                </e-column>


                                                                                <!-- 21.Resubmission -->
                                                                                <e-column field="resubmission"
                                                                                    width="140"
                                                                                    headerText="Resubmission"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-dropdownlist id="dropdown2"
                                                                                            placeholder="Select Resubmission"
                                                                                            [dataSource]="resumissiondropdata"
                                                                                            [popupHeight]="height">
                                                                                        </ejs-dropdownlist>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 22.Location -->
                                                                                <e-column field="clientLocation"
                                                                                    width="240" headerText="Location"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                                <!-- 23.Phone -->
                                                                                <e-column field="clientPhone"
                                                                                    width="240" headerText="Phone"
                                                                                    type="string">
                                                                                    <ng-template #filterTemplate
                                                                                        let-data>
                                                                                        <ejs-maskedtextbox
                                                                                            placeholder="Enter the value">
                                                                                        </ejs-maskedtextbox>
                                                                                    </ng-template>
                                                                                </e-column>

                                                                                <e-column field="underBilled"
                                                                                    width="140"
                                                                                    headerText="UnderBilled"
                                                                                    type="string"
                                                                                    [allowFiltering]="false"
                                                                                    [allowSorting]='true'>
                                                                                </e-column>


                                                                                <!--24.Settings--->
                                                                                <e-column width="50"
                                                                                    [showInColumnChooser]="false">
                                                                                    <ng-template #headerTemplate
                                                                                        let-data>
                                                                                        <div class="d-none d-lg-block">
                                                                                            <span id="show"
                                                                                                (click)="show()"><i
                                                                                                    class="fa fa-cog fa-lg"
                                                                                                    aria-hidden="true">
                                                                                                </i></span>
                                                                                        </div>
                                                                                    </ng-template>
                                                                                </e-column>
                                                                            </e-columns>
                                                                        </ejs-grid>
                                                                         <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update ClaimsTotalColumns constant in claims-list.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'ClaimsGrid' maps to localStorage key 'gridClaimsGrid'
                                                                          -->
                                                                    </div>
                                                                    <div class="col-lg-12">
                                                                        <div *ngIf="ClaimsDataList.length == 0"
                                                                            class="text-center" style="color:red">
                                                                            <p>No data available</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
    </div>
    <ng-template #elsecondition>
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to
                                view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
<!-- exportascsvmodel -->

<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Export as CSV</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportClaimsWithPaginationCsv()">
                            Print Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportClaimsCsv()">
                            Print All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!--openBulkDelete  -->

<span id="openBulkDelete" data-bs-toggle="modal" data-bs-target="#modalBulkdelete"></span>
<div class="modal fade" id="modalBulkdelete" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteMultipleClaims()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<!--  delete single claims-->
<span id="opendeleteclaim" data-bs-target="#deleteclaim" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteclaim" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteClaim()">
                    Delete
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<!-- for batch -->

<span id="batchopen" data-bs-toggle="modal" data-bs-target="#batchinfo"></span>
<div class="modal hide fade modalbackgrod" id="batchinfo" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Batch Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"  aria-label="Close" (click)="isViewbatches=false"></button>
            </div>
            <div class="modal-body modal-body1">
                <div class="row">
                    <div class="col-lg-12 ms-3">
                        <app-batches *ngIf="isViewbatches"></app-batches>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                    (click)="isViewbatches=false">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- for qr -->

<span id="QRInvoiceopen" data-bs-toggle="modal" data-bs-target="#QRInvoiceinfo"></span>
<div class="modal hide fade modalbackgrod" id="QRInvoiceinfo" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Payment QR Details</h5>
                <button type="button" class="close" data-bs-dismiss="modal" (click)="isViewQR=false">&times;</button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 ms-3">
                        <app-qr-barcode-invoice *ngIf="isViewQR">
                        </app-qr-barcode-invoice>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                    (click)="isViewQR=false">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Create Batch Details -->
<!---------------------------------------------Batch creation--------------------------------------------->
<span id="openModal1" data-bs-target="#CreateBatchDetail" data-bs-toggle="modal"></span>
<div class="modal fade" id="CreateBatchDetail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Created Batch Details</h5>
                <button type="button" class="close" data-bs-dismiss="modal">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <table class="table table-hover table-bordered mt-3">
                    <thead>
                        <th class="pointer" style="background-color: #00786a; color: white">Batch No.</th>
                        <th class="pointer">Filepath</th>
                        <th class="pointer" style="text-align: center">Download</th>
                        <th class="pointer" style="text-align: center">View</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="width: 100px;background-color:#fff; color: black;">
                                {{ CreatedBatchList?.batchno }}
                            </td>
                            <td style="width: 100px">
                                {{ CreatedBatchList?.fileName }}
                            </td>
                            <td class="text-center p-0">
                                <button class="btn blue-btn btn-sm mr-2"
                                    (click)="downloadFile(CreatedBatchList?.filePath)">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </td>
                            <td class="text-center p-0">
                                <button class="btn blue-btn btn-sm" (click)="GenerateReport(CreatedBatchList)">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <div class="text-right">
                    <button class="btn blue-btn btn-sm text-right" type="button" data-bs-dismiss="modal"
                        id="CloseCreatedBatchDetails">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ...........................................View 837 Report............................... -->
<span id="openCreate837Modal" data-bs-toggle="modal" data-bs-target="#View837Create"></span>
<div class="modal fade" id="View837Create" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{ReportHeader}}</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="close837Modal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="ReportView== true">
                    <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<!-- view 837 for create button -->
<span id="OpenviewbatchFile" data-bs-target="#viewbatchFile" data-bs-toggle="modal"></span>
<div class="modal fade hide modalbackgrod " id="viewbatchFile" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">View 837</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="viewbatchFileclose()">
                        Close
                    </button>
                    <button (click)="kendopdfdownloadList()" class="btn blue-btn btn-sm">
                        Download
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="reportscroll">
                    <kendo-pdf-export #pdflist paperSize="A4">
                        <div id="page_1" style="width: 730px">
                            <div class="row pl-0 pr-0">
                                <div class="col-lg-10">
                                    <h5>Exported Claims Report</h5>
                                </div>
                                <div class="col-lg-2">{{ today }}</div>
                            </div>
                            <div class="row pl-0 pr-0">
                                <div class="col-lg-12 font-weight-bold">
                                    File Name:{{ CreatedBatchList?.invoice837P?.file_Name }}
                                </div>
                            </div>
                            <div class="row pl-0 pr-0">
                                <div class="col-lg-12 font-weight-bold">
                                    File Creation Date:{{
                                    CreatedBatchList?.invoice837P?.file_Creation_Date
                                    | date: "MM/dd/yyyy"
                                    }}
                                </div>
                            </div>
                            <div class="row pl-0 pr-0">
                                <div class="col-lg-12 font-weight-bold">
                                    Submission/Control Num:
                                    {{ CreatedBatchList?.invoice837P?.submission_Control_Number }}
                                </div>
                            </div>
                            <div class="row pl-0 pr-0 w-100">
                                <div class="col-lg-1 pr-0 font-weight-bold">Claim ID</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">From Date</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">To Date</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">POS</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Procedure</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Modifier</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Rendering</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Last Name</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Units</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Charges</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Net</div>
                                <div class="col-lg-1 pl-0 pr-0 font-weight-bold">Balance</div>
                            </div>
                            <hr style="
                  margin-top: 1.5%;
                  border-top: 1px solid rgb(19, 17, 17);
                  width: 100%;
                  box-shadow: 0px 1px 1px #0c0c0c;
                " />
                            <div *ngFor="
                  let companyClaim of CreatedBatchList?.invoice837P    ?.companyClaims
                ">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h5>{{ companyClaim.companyName }}</h5>
                                    </div>
                                </div>

                                <div *ngFor="let val of companyClaim.claimDetail837PInvoice">
                                    <div class="row pl-0 pr-0">
                                        <div class="col-lg-4 pr-0 font-weight-bolder">
                                            {{ val?.payor_Name }}
                                        </div>
                                        <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                                            {{ val?.payor_Id }}
                                        </div>
                                    </div>
                                    <div *ngFor="let val2 of val?.claimDetail">
                                        <div class="row pl-0 pr-0 ">
                                            <div class="col-lg-4 pr-0 font-weight-bolder">
                                                {{ val2?.client_Last_Name }},&nbsp;{{
                                                val2?.client_First_Name
                                                }}&nbsp;
                                                {{
                                                val2?.client_Middle_Name != null
                                                ? val?.client_Middle_Name
                                                : ""
                                                }}
                                            </div>
                                            <div class="col-lg-4 pl-0 pr-0 font-weight-bolder">
                                                ID:{{ val2?.insurence_No }}
                                            </div>
                                        </div>
                                        <div *ngFor="let val1 of val2?.serviceInvoice837P">
                                            <hr style="
                      margin-top: 1.5%;
                      border-top: 1px solid grey(19, 17, 17);
                      width: 100%;
                    
                    " />
                                            <div class="row pl-0 pr-0">
                                                <div class="col-lg-1">{{ val2?.claim_No }}</div>

                                                <div class="col-lg-1 pl-0 pr-0">
                                                    {{ val1?.serviceDate | date: "MM/dd/yyyy" }}
                                                </div>
                                                <div class="col-lg-1 pl-0 pr-0">
                                                    {{ val1?.serviceDate | date: "MM/dd/yyyy" }}
                                                </div>
                                                <div class="col-lg-1 pl-0 pr-0">
                                                    {{ val1?.service_Location }} &nbsp; {{ val1?.service_Code }}
                                                </div>
                                                <!-- <div class="col-lg-1 pl-0 pr-0">
                         
                        </div> -->
                                                <div class="col-lg-1 pl-0 pr-0">
                                                    {{val1?.modifier1}} <span
                                                        *ngIf="val1?.modifier2 != null && val1?.modifier2 != undefined">.</span>
                                                    {{val1?.modifier2}}
                                                    <span
                                                        *ngIf="val1?.modifier3 != null && val1?.modifier3 != undefined">.</span>
                                                    {{val1?.modifier3}} <span
                                                        *ngIf="val1?.modifier4 != null && val1?.modifier4 != undefined">.</span>
                                                    {{val1?.modifier4}}
                                                </div>
                                                <div class="col-lg-3 pl-0 pr-0">
                                                    {{ val1?.rendering_Firstname }} &nbsp; {{ val1?.rendering_LastName
                                                    }}
                                                </div>
                                                <!-- <div class="col-lg-1 pl-0 pr-0">
                         
                        </div> -->
                                                <div class="col-lg-1 pl-0 pr-0">
                                                    {{ val1?.totalUnits }}
                                                </div>
                                                <div class="col-lg-1 pl-0 pr-0  ms-1">
                                                    ${{ val1?.totalCharges }}
                                                </div>
                                                <div class="col-lg-1 pl-0 pr-0">
                                                    ${{ val1?.totalNetCharges }}
                                                </div>
                                                <div class="col-lg-0 pl-0 pr-0">
                                                    ${{ val1?.balanceAmount }}
                                                </div>
                                            </div>
                                            <ng-template kendoPDFTemplate let-pageNum="pageNum"
                                                let-totalPages="totalPages">
                                                <div class="kendofooter">
                                                    <div></div>
                                                    <div> </div>

                                                </div>
                                            </ng-template>
                                        </div>
                                        <div class="row pl-0 pr-0 ">
                                            <div class="col-lg-1 pr-0 font-weight-bold">Total:</div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"></div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold">{{ val2?.totalUnits }}
                                            </div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold">${{ val2?.totalCharges }}
                                            </div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold"> ${{val2?.totalNetCharges}}
                                            </div>
                                            <div class="col-lg-1 pl-0 pr-0 font-weight-bold">
                                                ${{val2?.totalBalancaCharges }}</div>

                                        </div>
                                        <hr style="
                    margin-top: 1.5%;
                    border-top: 1px solid rgb(19, 17, 17);
                    width: 100%;
                    box-shadow: 0px 1px 1px #0c0c0c;
                  " />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6"></div>
                                <div class="col-lg-2">Grand Totals:</div>
                                <div class="col-lg-1 pl-0 pr-0">
                                    {{ CreatedBatchList?.invoice837P?.totalUnits }}
                                </div>
                                <div class="col-lg-1 pl-0 pr-0">
                                    ${{ CreatedBatchList?.invoice837P?.totalCharges }}
                                </div>

                                <div class="col-lg-1 pl-0 pr-0">
                                    ${{ CreatedBatchList?.invoice837P?.totalNetCharges }}
                                </div>

                                <div class="col-lg-1 pl-0 pr-0">
                                    ${{ CreatedBatchList?.invoice837P?.totalBalance }}
                                </div>
                            </div>
                        </div>
                    </kendo-pdf-export>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Loader -->



<!-- markAsPaid -->
<span id="openMarkPaidModal" data-bs-target="#markAsPaid" data-bs-toggle="modal"></span>
<div class="modal fade" id="markAsPaid" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Pay details</h5>
                <button type="button" class="close" data-bs-dismiss="modal">
                    &times;
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label class="center-block col-lg-3 col-md-3 col-sm-12 col-xs-12">Paid Date<sup
                                    class="super-script">*</sup></label>
                            <my-date-picker class=" col-lg-7 col-md-7 col-sm-12 col-xs-12" name="nmapaiddate"
                                [options]="myDatePickerOptionsheader" [selDate]="MarkServiceAsPaid.paidDate"
                                (inputFieldChanged)="MarkPaiddatechange($event)"
                                (dateChanged)="onMarkPaidDateChanged($event)" required>
                            </my-date-picker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label class="center-block col-lg-3 col-md-3 mb-0 col-sm-12 col-xs-12">Type of pay<sup
                                    class="super-script">*</sup></label>
                            <input type="radio" [value]="'net'" class=" ms-3"
                                [(ngModel)]="MarkServiceAsPaid.typeofpay">&nbsp;&nbsp;Net
                            charges
                            <input type="radio" [value]="'gross'" class=" ms-4"
                                [(ngModel)]="MarkServiceAsPaid.typeofpay" />&nbsp;&nbsp;Gross Charges
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn blue-btn btn-sm" (click)="MarkServicePaid()"
                        [disabled]="(MarkServiceAsPaid.typeofpay==null||MarkServiceAsPaid.typeofpay==undefined||MarkServiceAsPaid.typeofpay==''||MarkServiceAsPaid.paidDate==undefined||MarkServiceAsPaid.paidDate==null||MarkServiceAsPaid.paidDate=='')">
                        <span> Save & Close</span>
                    </button>
                    <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>


<span id="UACModalOpen" data-bs-toggle="modal" data-bs-target="#viewUACLetterModal"></span>
<div class="modal hide fade modalbackgrod" id="viewUACLetterModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" style="max-width:796.8px;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">UAC Letter</h5>
                <button type="button" class="close" data-bs-dismiss="modal" (click)="closeUACLetter();">&times;</button>
            </div>
            <div class="modal-body modal-body1">
                <div class="row">
                    <div class="col-12">
                        <app-uac-coversheet *ngIf="isViewUACLetter"></app-uac-coversheet>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                    (click)="closeUACLetter();">Close</button>
            </div>
        </div>
    </div>
</div>